import React from 'react';
import { ArrowRight, Download, Sparkles } from 'lucide-react';
import { heroStats } from '../../mock/data';
import HeroStatCard from './HeroStatCard';

export default function HeroContent() {
  return (
    <div>
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[var(--pca-border)] shadow-sm text-[13px] text-[#0B2E6E] font-medium">
        <Sparkles size={14} className="text-blue-500" />
        Admissions Open 2025-26 · B.Pharm &amp; D.Pharm
      </div>

      <h1 className="h-display mt-6 text-[44px] leading-[1.05] md:text-[64px] md:leading-[1.02]">
        Your Future <span className="text-[var(--pca-blue)]">Starts Here.</span>
      </h1>
      <p className="mt-5 text-slate-600 text-lg max-w-xl">
        Build a successful career in Pharmacy with PCI Approved Education and 26+ Years of Excellence.
      </p>

      <div className="mt-8 flex flex-wrap items-center gap-3">
        <a href="#admissions" className="btn-primary">
          Apply Now <ArrowRight size={18} />
        </a>
        <button className="btn-outline" type="button">
          <Download size={16} /> Download Brochure
        </button>
      </div>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {heroStats.map((s, i) => (
          <HeroStatCard key={s.label} raw={s.value} label={s.label} delay={i * 120} />
        ))}
      </div>
    </div>
  );
}
